export interface resultObj {
  addedUnitsGraphData: addedGraph[];
  statusGraph: statusGraph[];
  provisionedUnits: countGraph[];
  unprovisionedUnits: countGraph[];
  monitoredUnits: countGraph[];
  unmonitoredUnits: countGraph[];
}
export interface addedGraph {
  count: number;
  Month: number;
  Year: string;
}
export interface statusGraph {
  count: number;
  status: string;
}
export interface countGraph {
  count: number;
}
export class monitorProvisionObj {
  system_ip: string;
  system_name: string;
  processingFlag: boolean;
  resultSuccessFlag: boolean;
  resultFailedFlag: boolean;
  parentFolder: string;

  constructor(ip, name, parent, flag1 = false, flag2 = false, flag3 = false) {
    this.system_ip = ip;
    this.system_name = name;
    this.parentFolder = parent;
    this.processingFlag = flag1;
    this.resultSuccessFlag = flag2;
    this.resultFailedFlag = flag3;
  }
}

export class statusUnitObj {
  system_ip: string;
  system_name: string;
  processingFlag: boolean;
  resultSuccessFlag: boolean;
  resultFailedFlag: boolean;
  parentFolder: string;
  status: string;

  constructor(ip, name, parent, status, flag1 = false, flag2 = false, flag3 = false) {
    this.system_ip = ip;
    this.system_name = name;
    this.parentFolder = parent;
    this.processingFlag = flag1;
    this.resultSuccessFlag = flag2;
    this.resultFailedFlag = flag3;
    this.status = status;
  }
}
